'use strict';

var _SimpleSigner = require('./SimpleSigner');

var _SimpleSigner2 = _interopRequireDefault(_SimpleSigner);

var _JWT = require('./JWT');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = { SimpleSigner: _SimpleSigner2.default, verifyJWT: _JWT.verifyJWT, createJWT: _JWT.createJWT, decodeJWT: _JWT.decodeJWT };


//////////////////
// WEBPACK FOOTER
// ./~/uport-transports/~/did-jwt/lib/index.js
// module id = 916
// module chunks = 0